import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const CountLabel = styled.div`
  display: flex;
  gap: ${theme.spacings.xxsmall};
  margin-bottom: 45px;
`;

export const Headerinline = styled.span`
  display: flex;
`;

export const HeadCollumn = styled.div`
  display: flex;
  .one{
    position: relative;
    left: 45px;
  }
  .two{
    position: relative;
    left: 21%;
  }
  .three{
    position: relative;
    left: 30%;
  }
  .four{
    position: relative;
    left: 36%;
  }
  .five{
    position: relative;
    left: 44%;
  }
  .six{
    position: relative;
    left: 53%;
  }
  .seven{
    position: relative;
    left: 62%;
  }
  @media only screen and (max-width: 1273px) {
    .one{
      position: relative;
      left: 30px;
    }
    .two{
      position: relative;
      left: 5%;
    }
    .three{
      position: relative;
      left: 20%;
    }
    .four{
      position: relative;
      left: 25%;
    }
    .five{
      position: relative;
      left: 30%;
    }
    .six{
      position: relative;
      left: 35%;
    }
    .seven{
      position: relative;
      left: 40%;
    }
  }
`;

export const Nav = styled.ul`
  display: flex;
  gap: 1rem;
  margin-bottom: 5rem;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  list-style: none;

  li.active {
    opacity: 0.8;
    pointer-events: none;

  }
`;

export const Link = styled.a`
  color: white;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
  box-shadow: ${theme.shadow.lv1};
  background-color: ${theme.colors.primaryBlue};
  transition: all 0.5s;
  line-height: 22px;

  :hover {
    opacity: 0.8;
  }
`;
